const ka = {
  "भाजपा सदस्यता अभियान - 2024": "ಬಿಜೆಪಿ ಸದಸ್ಯತ್ವ ಅಭಿಯಾನ - 2024",
  "Select Language": "ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
  Next: "ಮುಂದೆ",
  "Enter your mobile number": "ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
  "I accept the Terms and Conditions, and by continuing, I consent to voluntarily become a member of the BJP":
    "ನಾನು ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ಒಪ್ಪಿಕೊಳ್ಳುತ್ತೇನೆ ಮತ್ತು ಮುಂದುವರಿಯುವ ಮೂಲಕ ನಾನು ಸ್ವಯಂಪ್ರೇರಣೆಯಿಂದ बीजेपीಯ ಸದಸ್ಯನಾಗಲು ಸಮ್ಮತಿಸುತ್ತೇನೆ",
  "Get OTP": "OTP ಪಡೆಯಿರಿ",
  "Terms and Conditions": "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
  "You must tick the box to continue, as it is mandatory.":
    "ಮುಂದುವರಿಯಲು ನೀವು ಬಾಕ್ಸ್ ಅನ್ನು ಟಿಕ್ ಮಾಡಬೇಕು, ಏಕೆಂದರೆ ಅದು ಕಡ್ಡಾಯವಾಗಿದೆ.",
  "Okay, Got it": "ಸರಿ, ಅರ್ಥವಾಯಿತು",
  "Get OTP": "OTP ಪಡೆಯಿರಿ",
  "Enter OTP": "OTP ನಮೂದಿಸಿ",
  "Resend OTP": "OTP ಅನ್ನು ಮರುಕಳುಹಿಸಿ",
  Continue: "ಮುಂದುವರಿಸಿ",
  "Fill details": "ವಿವರಗಳನ್ನು ಭರ್ತಿ ಮಾಡಿ",
  "Upload Photo": "ಫೋಟೋ ಅಪ್ಲೋಡ್ ಮಾಡಿ",
  "Profile Photo": "ಪ್ರೊಫೈಲ್ ಫೋಟೋ",
  "Mobile number": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
  "Mrs.": "ಶ್ರೀಮತಿ",
  "Mr.": "ಶ್ರೀ",
  Ms: "ಶ್ರೀಮತಿ",
  "Full Name*": "ಪೂರ್ಣ ಹೆಸರು *",
  "D.O.B": "D.O.B",
  Age: "ವಯಸ್ಸು",
  Gender: "ಲಿಂಗ",
  Female: "ಹೆಣ್ಣು",
  Male: "ಪುರುಷ",
  Other: "ಇತರೆ",
  "Email Id": "ಇಮೇಲ್ ಐಡಿ",
  "Add address": "ವಿಳಾಸವನ್ನು ಸೇರಿಸಿ",
  "House/ Flat/ Floor No.": "ಮನೆ/ ಫ್ಲಾಟ್/ ಮಹಡಿ ಸಂಖ್ಯೆ.",
  "Current address PIN code": "ಪ್ರಸ್ತುತ ವಿಳಾಸ ಪಿನ್ ಕೋಡ್",
  "District*": "ಜಿಲ್ಲೆ*",
  State: "ರಾಜ್ಯ",
  "Assembly constituency (AC)": "ವಿಧಾನಸಭಾ ಕ್ಷೇತ್ರ (AC)",
  "Tell us about your location": "ನಿಮ್ಮ ಸ್ಥಳದ ಬಗ್ಗೆ ನಮಗೆ ತಿಳಿಸಿ",
  "It will assist us in locating other members in your area.":
    "ನಿಮ್ಮ ಪ್ರದೇಶದಲ್ಲಿ ಇತರ ಸದಸ್ಯರನ್ನು ಪತ್ತೆಹಚ್ಚಲು ಇದು ನಮಗೆ ಸಹಾಯ ಮಾಡುತ್ತದೆ.",
  "Your address as fetched": "ನಿಮ್ಮ ವಿಳಾಸವನ್ನು ತರಲಾಗಿದೆ",
  "Referral code": "ರೆಫರಲ್ ಕೋಡ್",
  "I certify that above provided information is correct and there is no mistake. I know that all further communication will be done on above provided details":
    "ಮೇಲೆ ನೀಡಿರುವ ಮಾಹಿತಿಯು ಸರಿಯಾಗಿದೆ ಮತ್ತು ಯಾವುದೇ ತಪ್ಪಿಲ್ಲ ಎಂದು ನಾನು ಪ್ರಮಾಣೀಕರಿಸುತ್ತೇನೆ. ಎಲ್ಲಾ ಹೆಚ್ಚಿನ ಸಂವಹನಗಳನ್ನು ಮೇಲೆ ಒದಗಿಸಿದ ವಿವರಗಳ ಮೇಲೆ ಮಾಡಲಾಗುತ್ತದೆ ಎಂದು ನನಗೆ ತಿಳಿದಿದೆ",
  Save: "ಉಳಿಸಿ",
  Select: "ಆಯ್ಕೆ ಮಾಡಿ",
  Camera: "ಕ್ಯಾಮೆರಾ",
  or: "ಅಥವಾ",
  Gallery: "ಗ್ಯಾಲರಿ",
  "Support format : Jpeg, Png, Pdf": "ಬೆಂಬಲ ಸ್ವರೂಪ: Jpeg, Png, Pdf",
  Cancel: "ರದ್ದುಮಾಡಿ",
  "Select location": "ಸ್ಥಳವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
  "Provide location": "ಸ್ಥಳವನ್ನು ಒದಗಿಸಿ",
  "Search results": "ಹುಡುಕಾಟ ಫಲಿತಾಂಶಗಳು",
  "Search for a building, street name or..": "ಕಟ್ಟಡ, ರಸ್ತೆ ಹೆಸರು ಅಥವಾ.. ಹುಡುಕಿ",
  "Your address as fetched": "ನಿಮ್ಮ ವಿಳಾಸವನ್ನು ತರಲಾಗಿದೆ",
  "Locate me": "ನನ್ನನ್ನು ಪತ್ತೆ ಮಾಡಿ",
  "Confirm location": "ಸ್ಥಳವನ್ನು ದೃಢೀಕರಿಸಿ",
  "Congratulations !": "ಅಭಿನಂದನೆಗಳು !",
  "Your primary Id is -": "ನಿಮ್ಮ ಪ್ರಾಥಮಿಕ ಐಡಿ -",
  "Login in to Bjp.org/membership to enhance your data, access your ID card, and refer others to join as primary members.":
    "ನಿಮ್ಮ ಡೇಟಾವನ್ನು ಹೆಚ್ಚಿಸಲು Bjp.org/membership ಗೆ ಲಾಗಿನ್ ಮಾಡಿ, ನಿಮ್ಮ ID ಕಾರ್ಡ್ ಅನ್ನು ಪ್ರವೇಶಿಸಿ ಮತ್ತು ಪ್ರಾಥಮಿಕ ಸದಸ್ಯರಾಗಿ ಸೇರಲು ಇತರರನ್ನು ಉಲ್ಲೇಖಿಸಿ.",
  "ID CARD": "ಗುರುತಿನ ಚೀಟಿ",
  "You can download your generated ID Card":
    "ನೀವು ರಚಿಸಿದ ಗುರುತಿನ ಚೀಟಿಯನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಬಹುದು",
  Download: "ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
  "Go to dashboard": "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ಗೆ ಹೋಗಿ",
  "View your profile": "ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ವೀಕ್ಷಿಸಿ",
  "Refer and add member": "ಉಲ್ಲೇಖಿಸಿ ಮತ್ತು ಸದಸ್ಯರನ್ನು ಸೇರಿಸಿ",
  Share: "ಹಂಚಿಕೊಳ್ಳಿ",
  "To update your additional details and refer more member, please click here.":
    "ನಿಮ್ಮ ಹೆಚ್ಚುವರಿ ವಿವರಗಳನ್ನು ನವೀಕರಿಸಲು ಮತ್ತು ಹೆಚ್ಚಿನ ಸದಸ್ಯರನ್ನು ಉಲ್ಲೇಖಿಸಲು, ದಯವಿಟ್ಟು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ.",
  "Bharatiya Janata Party": "ಭಾರತೀಯ ಜನತಾ ಪಕ್ಷ",
  "6A, DEENDAYAL UPADHYAYA MARG, NEW DELHI - 110002":
    "6A, ದೀನದಯಾಳ್ ಉಪಾಧ್ಯಾಯ ಮಾರ್ಗ, ಹೊಸ ದೆಹಲಿ - 110002",
  Name: "ಹೆಸರು",
  "Membership Number": "ಸದಸ್ಯತ್ವ ಸಂಖ್ಯೆ",
  "QR Code": "QR ಕೋಡ್",
  "Please select a year between 1930 and 2006.":
    "ದಯವಿಟ್ಟು 1930 ಮತ್ತು 2006 ರ ನಡುವಿನ ವರ್ಷವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
  "Please enter a valid email address.":
    "ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
  "Please enter 6-digit PIN code.": "ದಯವಿಟ್ಟು 6-ಅಂಕಿಯ ಪಿನ್ ಕೋಡ್ ನಮೂದಿಸಿ",
  "10-digit mobile number.": "10-ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
  "Please enter a 10-digit mobile number.":
    "ದಯವಿಟ್ಟು 10-ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
  "Please enter your name.": "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
  "I pledge and willing to receive regular updates from BJP":
    "ನಾನು ಪ್ರತಿಜ್ಞೆ ಮಾಡುತ್ತೇನೆ ಮತ್ತು ಬಿಜೆಪಿಯಿಂದ ನಿಯಮಿತವಾಗಿ ನವೀಕರಣಗಳನ್ನು ಸ್ವೀಕರಿಸಲು ಸಿದ್ಧನಿದ್ದೇನೆ",
  "Get Verification Code": "ದೃಢೀಕರಣ ಕೋಡ್ ಪಡೆಯಿರಿ",
  "Enter Verification Code": "ದೃಢೀಕರಣ ಕೋಡ್ ನಮೂದಿಸಿ",
  "Resend Verification Code": "ದೃಢೀಕರಣ ಕೋಡ್ ಪುನಃ ಕಳುಹಿಸಿ",
  "Provide Details": "ವಿವರ ನೀಡಿ",
  Upload: "ಅಪ್ಲೋಡ್ ಮಾಡಿ",
  Ok: "ಸರಿಯಾಗಿದೆ",
  Calendar: "ಕ್ಯಾಲೆಂಡರ್",
  "Full Address": "ಸಂಪೂರ್ಣ ವಿಳಾಸ",
  "Privacy policy": "ಗೋಪ್ಯತೆಯ ನೀತಿ",
  Disclaimer: "ನಿರಾಕರಣಾ ಪ್ರಕಟಣೆ",
  "Contact us": "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
  Save: "ಉಳಿಸು",
  "Your primary member ID": "ನಿಮ್ಮ ಪ್ರಾಥಮಿಕ ಸದಸ್ಯ ಐಡಿ",
  "Membership Card": "ಸದಸ್ಯತ್ವ ಕಾರ್ಡ್",
  "Your Unique Referral code": "ನಿಮ್ಮ ವಿಶಿಷ್ಟ ರೆಫರಲ್ ಕೋಡ್",
  "Invite and add member": "ಆಹ್ವಾನ ಕಳುಹಿಸಿ ಮತ್ತು ಸದಸ್ಯರನ್ನು ಸೇರಿಸಿ",
  Share: "ಹಂಚಿಕೊಳ್ಳಿ",
  "Click below to add more details, donate and add other members to BJP":
    "ಹೆಚ್ಚಿನ ವಿವರಗಳು ಸೇರಿಸಲು, ದಾನ ಮಾಡಲು ಮತ್ತು ಇತರ ಸದಸ್ಯರನ್ನು BJP ಸೇರಿಸಲು ಕ್ಲಿಕ್ ಮಾಡಿ",
  "Update your details": "ನಿಮ್ಮ ವಿವರಗಳನ್ನು ನವೀಕರಿಸಿ",
  "Add Referral Details": "ರೆಫರಲ್ ವಿವರಗಳನ್ನು ಸೇರಿಸಿ",
  "Referred by (name)": "(ಹೆಸರು) ಮೂಲಕ ಉಲ್ಲೇಖಿಸಲಾಗಿದೆ",
  "Referred by (mobile number)": "ಇವರಿಂದ ಉಲ್ಲೇಖಿಸಲಾಗಿದೆ (ಮೊಬೈಲ್ ಸಂಖ್ಯೆ)",
  Capture: "ಸೆರೆಹಿಡಿಯಿರಿ",
  "Close Camera": "ಕ್ಯಾಮರಾ ಮುಚ್ಚಿ",
  Uploading: "ಅಪ್‌ಲೋಡ್",
  "Your Unique Referral Link": "ನಿಮ್ಮ ವಿಶಿಷ್ಟ ರೆಫರಲ್ ಲಿಂಕ್",
  "You've reached the maximum OTP attempts for today. Please try again tomorrow":
    "ನೀವು ಇಂದಿನ ಗರಿಷ್ಠ OTP ಪ್ರಯತ್ನಗಳನ್ನು ತಲುಪಿರುವಿರಿ. ದಯವಿಟ್ಟು ನಾಳೆ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
  Miss: "ಶ್ರೀಮತಿ",
  "Full Name": "ಪೂರ್ಣ ಹೆಸರು",
  "OTP limit reached for today. Please try again tomorrow":
    "ಇಂದಿನ OTP ಮಿತಿಯನ್ನು ತಲುಪಿದೆ. ದಯವಿಟ್ಟು ನಾಳೆ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
  ": is not a Primary Member, Only Primary Members can refer":
    ": ಪ್ರಾಥಮಿಕ ಸದಸ್ಯರಲ್ಲ, ಪ್ರಾಥಮಿಕ ಸದಸ್ಯರು ಮಾತ್ರ ಉಲ್ಲೇಖಿಸಬಹುದು",
  "Please enter valid fullname": "ದಯವಿಟ್ಟು ಮಾನ್ಯ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
  Upload: "ಅಪ್ಲೋಡ್ ಮಾಡಿ",
};

export default ka;
